import React from "react";
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ListContent, BaasicButton } from "core/components";
import { Page, PageNavigation } from "core/layouts";
import { defaultTemplate } from 'core/hoc';
import { getPageObject } from 'core/utils';

const ListLayoutTemplate = function({
    title,
    onCreate,
    onCreateCsv,
    children,
    t,
    loading,
    authorization,
    store
}) {
    const { header, footer, navigation, content } = getPageObject(children);

    const {
        createFunc,
        createFuncCsv,
        isLoading
    } = resolveProps({ onCreate, onCreateCsv, loading, authorization, store });

    return (
        <Page title={title} loading={isLoading}>
            {navigation
                ? navigation
                : (<PageNavigation>
                        {createFunc && 
                        <BaasicButton authorized={authorization ? authorization.create : true} t={t} 
                            className="btn btn--base btn--primary" label={'LIST_LAYOUT.CREATE_BUTTON'} onClick={createFunc}></BaasicButton> }
                        {createFuncCsv && 
                        <BaasicButton authorized={authorization ? authorization.create : true} t={t} 
                            className="btn btn--base btn--primary" label={'LIST_LAYOUT.CREATE_BUTTON_CSV'} onClick={createFuncCsv}></BaasicButton> }
                  </PageNavigation>)
            }
            {header}
            {content.header}
            {content.sidebar}
            <ListContent>
                {content.children}
            </ListContent>
            {content.footer}
            {footer}
        </Page>
    );
};

ListLayoutTemplate.propTypes = {
    onCreate: PropTypes.func,
    onCreateCsv: PropTypes.func,
    title: PropTypes.string,
    loading: PropTypes.bool,
    children: PropTypes.any,
    t: PropTypes.func,
    authorization: PropTypes.any,
    store: PropTypes.object
};

// vice-versa compatibility with settings props as well as using store
function resolveProps({ onCreate, onCreateCsv, loading, authorization, store }) {
    return {
        createFunc: onCreate != null ? onCreate : (store && store.routes && store.routes.create ? store.routes.create : null),
        createFuncCsv: onCreateCsv != null ? onCreateCsv : (store && store.routes && store.routes.createCsv ? store.routes.createCsv : null),
        auth: authorization != null ? authorization : (store ? store.authorization : null),
        isLoading: _.isBoolean(loading)
            ? loading
            : (store ? store.loaderStore.initial && store.loaderStore.loading : false)
    }
}

export default defaultTemplate(ListLayoutTemplate);